import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { FiChevronRight } from "react-icons/fi";
import { useGetMenuListQuery } from "../../../components/products/productSlice";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { base_url } from "../../../server";

const managementServices = [
  { id: 2, name: "Project Management", url: "/project-management" },
  { id: 3, name: "Supply Chain Management", url: "/supply-chain-management" },
  {
    id: 4,
    name: "Export & Import Management",
    url: "/export-import-management",
  },
  { id: 5, name: "Wining Contracts", url: "/winning-contracts" },
  { id: 6, name: "Warranty Management", url: "/warranty-management" },
  { id: 7, name: "Procurement Management", url: "/procurement-management" },
  {
    id: 8,
    name: "Installation & Integration Services",
    url: "/installation-integration",
  },
];

function MobileMenu() {
  const isLogin = JSON.parse(window?.localStorage?.getItem("isLogin"));

  const { data: categoryData } = useGetMenuListQuery();

  const [data, setData] = useState(null);
  const [showSelectedSubMenu, setShowSelectedSubMenu] = useState({});
  const baseUrl = base_url();

  const getData = async () => {
    try {
      const res = await axios.get(`${baseUrl}category/filter`, {
        withCredentials: true,
      });
      setData(res.data);
    } catch (error) {
      console.error("An error occurred while fetching data:", error);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  const { t } = useTranslation();

  const openSubMenu = (name) => {
    setShowSelectedSubMenu((prev) => {
      const updatedState = {};
      Object.keys(prev).forEach((key) => {
        updatedState[key] = false;
      });

      updatedState[name] = !prev[name];
      return updatedState;
    });
  };

  return (
    <div
      className="collapse navbar-collapse mean-menu show"
      id="navbarSupportedContent1"
    >
      {/* <ul className="navbar-nav m-0 p-0">
        <li className="nav-item">
          <Link to="/products" className="nav-link">
            {t("All Products")}
            <i className="bx bx-chevron-down"></i>
          </Link>
        </li>

        {data &&
          data.map((item, i) => (
            <div className="add" key={i}>
              <li className="nav-item my-item">
                <Link
                  to="#"
                  className="nav-link"
                  onClick={() => openSubMenu(item.title.name)}
                >
                  {item?.title?.name}
                  <i className="bx bx-chevron-down"></i>
                </Link>
                {item?.Submenu?.length > 0 && (
                  <ul
                    className={`dropdown-menu dropAgro drop ${
                      showSelectedSubMenu[item.title.name] ? "active" : ""
                    } `}
                  >
                    <div className="row">
                      <div className="col-lg-3 width-100pr">
                        <div className="menuList" style={{ paddingTop: "0px" }}>
                          <ul>
                            {item.Submenu &&
                              item.Submenu.map((subItem) => (
                                <li className="nav-item" key={subItem._id}>
                                  <Link
                                    to={`product/category/${subItem._id}`}
                                    className="nav-link sub_menu_Text"
                                  >
                                    <FiChevronRight /> {subItem.name}
                                  </Link>
                                </li>
                              ))}
                          </ul>
                        </div>
                      </div>
                    </div>
                  </ul>
                )}
              </li>
              <p>{!showSelectedSubMenu[item.title.name] ? " + " : " - "} </p>
            </div>
          ))}

        {isLogin && (
          <li className="nav-item">
            <Link to="/" className="nav-link">
              {t("Services")}
            </Link>
          </li>
        )}
      </ul> */}
      <ul className="navbar-nav">
        <li className="nav-item mobileHide">
          <Link to="/" className="nav-link">
            {t("Home")}
          </Link>
        </li>
        <li className="nav-item mobileHide">
          <Link to="/about" className="nav-link">
            {t("About Us")}
          </Link>
        </li>
        <div className="dropdown categoryDropdown">
          <button
            className="btn btn-secondary dropdown-toggle"
            type="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            All Categories
          </button>
          <ul className="dropdown-menu">
            <li className="nav-item">
              <Link to={`/maintenance-stairs`} className="nav-link">
                GGAS Maintenance Stairs
              </Link>
            </li>
            <li className="nav-item">
              <Link to={`/service-carts`} className="nav-link">
                GGAS Service Carts
              </Link>
            </li>
            <li className="nav-item">
              <Link to={`/tool-solutions`} className="nav-link">
                Tool Solutions
              </Link>
            </li>
            <li className="nav-item">
              {/* <Link to={`/tool-control-solutions`} className="nav-link"> */}
              <Link to={`/`} className="nav-link">
                Tool Control Solutions
              </Link>
            </li>

            {/* {categoriesDatas?.map((item, i) => {
                          return (
                            <li className="nav-item" key={i}>
                              <Link
                                to={`/product/category/${item.uid}/${item?.slug}`}
                                className="nav-link"
                              >
                                {item?.name}
                                <i className="bx bx-chevron-down"></i>
                              </Link>
                            </li>
                          );
                        })} */}
          </ul>
        </div>

        {/* {data &&
                  data?.map((item, i) => {
                    return (
                      <li className="nav-item mobileHide perent" key={i}>
                        <Link
                          to={`product/category/${item?.title.uid}/${item?.title?.slug}`}
                          className="nav-link"
                        >
                          {item?.title?.name}
                          <i className="bx bx-chevron-down"></i>
                        </Link>
      
                        {item?.Submenu?.length > 0 && (
                          <ul className={`dropdown-menu dropAgro ${i}`}>
                            <div className="row">
                              <div className="col-lg-3 width-100pr">
                                <div
                                  className="menuList"
                                  style={{ paddingTop: "0px" }}
                                >
                                  <ul>
                                    {item?.Submenu &&
                                      item?.Submenu?.map((item) => {
                                        return (
                                          <li className="nav-item" key={item?._id}>
                                            <Link
                                              to={`product/category/${item?._id}`}
                                              className="nav-link sub_menu_Text"
                                            >
                                              <FiChevronRight /> {item?.name}
                                            </Link>
                                          </li>
                                        );
                                      })}
                                  </ul>
                                </div>
                              </div>
                            </div>
                          </ul>
                        )}
                      </li>
                    );
                  })} */}
        <div className="dropdown categoryDropdown">
          <button
            className="btn btn-secondary dropdown-toggle"
            type="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            Services
          </button>
          <ul className="dropdown-menu">
            {managementServices?.map((item, i) => {
              return (
                <li className="nav-item ps-0" key={i}>
                  <Link to={`/service${item.url}`} className="nav-link">
                    {item?.name}
                  </Link>
                </li>
              );
            })}
          </ul>
        </div>

       
        <li className="nav-item mobileHide">
          <Link to="/faq" className="nav-link">
            FAQ
            <i className="bx bx-chevron-down"></i>
          </Link>
        </li>
        <li className="nav-item mobileHide">
          <Link to="/careers" className="nav-link">
            Career
            <i className="bx bx-chevron-down"></i>
          </Link>
        </li>
        <li className="nav-item mobileHide">
          <Link to="/contact" className="nav-link">
            Contact Us
            <i className="bx bx-chevron-down"></i>
          </Link>
        </li>

        {isLogin === true && (
          <li className="nav-item ">
            <Link to="/" className="nav-link">
              Services
            </Link>
          </li>
        )}
      </ul>
    </div>
  );
}

export default MobileMenu;
